import EventEmitter from 'eventemitter3';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var observer = new MutationObserver(onMutate);
var mutationEventEmitter = new EventEmitter();
var mutationQueue = [];
var currentlyObserving = false;
var willProcessMutationQueue = false;
function onMutate(mutations) {
  for (var _iterator = _createForOfIteratorHelperLoose(mutations), _step; !(_step = _iterator()).done;) {
    var mutation = _step.value;
    if (mutation.type === "childList") {
      mutation.removedNodes.forEach(function (node) {
        node.nodeType === 1 && mutationEventEmitter.emit("removeNode", node);
      });
      mutation.addedNodes.forEach(function (node) {
        node.nodeType === 1 && mutationEventEmitter.emit("addNode", node);
      });
    }
    if (mutation.type === "attributes") {
      var el = mutation.target;
      var name = mutation.attributeName;
      var oldValue = mutation.oldValue;
      if (!el.hasAttribute(name)) {
        mutationEventEmitter.emit("removeAttribute", el, name, oldValue);
      } else if (oldValue === null) {
        mutationEventEmitter.emit("addAttribute", el, name, el.getAttribute(name));
      } else {
        var newValue = el.getAttribute(name);
        if (oldValue !== newValue) {
          mutationEventEmitter.emit("changeAttribute", el, name, oldValue, newValue);
        }
      }
    }
  }
}
function startObserving() {
  if (currentlyObserving) {
    return;
  }
  observer.observe(document, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeOldValue: true
  });
  currentlyObserving = true;
}
function stopObserving() {
  if (!currentlyObserving) {
    return;
  }
  flushObserver();
  observer.disconnect();
  currentlyObserving = false;
}

/**
 * Выполнение модификаций над DOM-деревом, не дёргая MutationObserver.
 * @param {function} callback
 */
function mutateDOM(callback) {
  if (currentlyObserving) {
    stopObserving();
    callback();
    startObserving();
  } else {
    callback();
  }
}

/**
 * Обработка мутаций, находящихся в MutationObserver, после текущего
 * стэка выполнения.
 * Добавление мутаций в массив позволяет вызывать startObserving и stopObserving
 * сколько угодно раз в пределах исполняемого стека задач.
 */
function flushObserver() {
  mutationQueue = mutationQueue.concat(observer.takeRecords());
  if (mutationQueue.length && !willProcessMutationQueue) {
    willProcessMutationQueue = true;
    queueMicrotask(function () {
      processMutationQueue();
      willProcessMutationQueue = false;
    });
  }
}

/**
 * Обработка мутаций, накопившхся в процессе исполняемого стэка задач.
 */
function processMutationQueue() {
  onMutate(mutationQueue);
  mutationQueue.length = 0;
}

/**
 * Разделение строки по пробельным символам и удаление дубликатов.
 * @param {string} value
 * @returns {string[]}
 */
function splitAndRemoveDuplicates(value) {
  var trimmedValue = value.trim();
  if (!trimmedValue) {
    return [];
  }
  return trimmedValue.split(/\s+/).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
}

/**
 * Возвращает разность двух множеств, представленных в виде массивов.
 * @param {string[]} arr1
 * @param {string[]} arr2
 */
function arrayDifference(arr1, arr2) {
  return arr1.filter(function (x) {
    return !arr2.includes(x);
  });
}

/**
 * Удаление элемента из массива.
 * @param {*[]} array
 * @param {*} item
 */
function removeFromArray(array, item) {
  for (var i = array.length - 1; i >= 0; i--) {
    if (array[i] === item) {
      array.splice(i, 1);
    }
  }
}

/**
 * Вызов события на DOM-элементе.
 * @param {Node, Document} el
 * @param {string} name
 * @param {Object} detail
 */
function dispatch(el, name, detail) {
  if (detail === void 0) {
    detail = {};
  }
  el.dispatchEvent(new CustomEvent(name, {
    detail: detail,
    bubbles: true,
    // Allows events to pass the shadow DOM barrier.
    composed: true,
    cancelable: true
  }));
}

var ATTRIBUTE_NAME = "data-xclass";
var SELECTOR = "[" + ATTRIBUTE_NAME + "]";
var APPLIED_WIDGETS_PROPERTY_NAME = "_xclass_applied";
var isFirstStart = true;

/**
 * @typedef widgetObject
 * @property {function(element: HTMLElement, self: widgetObject)} [init]
 * @property {function(element: HTMLElement, self: widgetObject)} [destroy]
 * @property {function(self: widgetObject)} [onRegister]
 * @property {string[]} [dependencies]
 */

var XClass = {
  _registered: new Map(),
  mutateDOM: mutateDOM,
  start: function start() {
    var _this = this;
    if (!document.body) {
      console.warn("XClass Warning: Unable to initialize. " + "Trying to load XClass before `<body>` is available. " + "Did you forget to add `defer` in XClass's `<script>` tag?");
    }
    startObserving();
    if (isFirstStart) {
      isFirstStart = false;
      mutationEventEmitter.on("addNode", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(node) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.initTree(node);
              case 2:
                return _context.abrupt("return", _context.sent);
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).on("removeNode", /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(node) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.destroyTree(node);
              case 2:
                return _context2.abrupt("return", _context2.sent);
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).on("addAttribute", /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(node, name, value) {
          var widgetsToApply;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (!(name === ATTRIBUTE_NAME)) {
                  _context3.next = 4;
                  break;
                }
                widgetsToApply = splitAndRemoveDuplicates(value);
                _context3.next = 4;
                return _this._initWidget.apply(_this, [node].concat(widgetsToApply));
              case 4:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x3, _x4, _x5) {
          return _ref3.apply(this, arguments);
        };
      }()).on("changeAttribute", /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(node, name, oldValue, newValue) {
          var oldValueItems, newValueItems, widgetsToApply, widgetsToRemove;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (!(name === ATTRIBUTE_NAME)) {
                  _context4.next = 9;
                  break;
                }
                oldValueItems = splitAndRemoveDuplicates(oldValue);
                newValueItems = splitAndRemoveDuplicates(newValue);
                widgetsToApply = arrayDifference(newValueItems, oldValueItems);
                widgetsToRemove = arrayDifference(oldValueItems, newValueItems);
                _context4.next = 7;
                return _this._destroyWidget.apply(_this, [node].concat(widgetsToRemove));
              case 7:
                _context4.next = 9;
                return _this._initWidget.apply(_this, [node].concat(widgetsToApply));
              case 9:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x6, _x7, _x8, _x9) {
          return _ref4.apply(this, arguments);
        };
      }()).on("removeAttribute", /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(node, name, oldValue) {
          var widgetsToRemove;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                if (!(name === ATTRIBUTE_NAME)) {
                  _context5.next = 4;
                  break;
                }
                widgetsToRemove = splitAndRemoveDuplicates(oldValue);
                _context5.next = 4;
                return _this._destroyWidget.apply(_this, [node].concat(widgetsToRemove));
              case 4:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x10, _x11, _x12) {
          return _ref5.apply(this, arguments);
        };
      }());
      this.initTree().then(function () {
        dispatch(document, "xclass:initialized");
      });
    }
  },
  stop: function stop() {
    stopObserving();
  },
  /**
   * Регистрация нового виджета под указанным именем.
   * @param {string} name
   * @param {widgetObject} widgetObject
   */
  register: function register(name, widgetObject) {
    if (this._registered.has(name)) {
      throw new Error("Widget \"" + name + "\" is already registered.");
    }
    this._registered.set(name, widgetObject);
    var onRegisterMethod = widgetObject["onRegister"];
    onRegisterMethod && onRegisterMethod.call(widgetObject, widgetObject);
    dispatch(document, "xclass:registered", {
      name: name,
      widgetObject: widgetObject
    });
  },
  /**
   * Проверка применён ли виджет к указанному элементу.
   * @param {HTMLElement} element
   * @param {string} name
   * @returns {boolean}
   */
  isWidgetApplied: function isWidgetApplied(element, name) {
    var appliedWidgets = element[APPLIED_WIDGETS_PROPERTY_NAME];
    return Array.isArray(appliedWidgets) && appliedWidgets.includes(name);
  },
  /**
   * Применение виджета(-ов) к элементу.
   * @param {HTMLElement} element
   * @param {string} names
   */
  addWidget: function addWidget(element) {
    var _this2 = this;
    var attributeValue = element.getAttribute(ATTRIBUTE_NAME) || "";
    var attributeItems = splitAndRemoveDuplicates(attributeValue);
    for (var _len = arguments.length, names = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      names[_key - 1] = arguments[_key];
    }
    var promises = names.map(function (name) {
      if (_this2.isWidgetApplied(element, name)) {
        console.warn("Widget \"" + name + "\" has already been applied to this element.");
        return Promise.resolve();
      }
      attributeItems.push(name);
      return _this2._initWidget(element, name);
    });
    Promise.allSettled(promises).then(function () {
      mutateDOM(function () {
        if (attributeItems.length) {
          element.setAttribute(ATTRIBUTE_NAME, attributeItems.join(" "));
        } else {
          element.removeAttribute(ATTRIBUTE_NAME);
        }
      });
    });
  },
  /**
   * Освобождение ресурсов виджета(-ов), применённого к элементу.
   * @param {HTMLElement} element
   * @param {string} names
   */
  deleteWidget: function deleteWidget(element) {
    var _this3 = this;
    var attributeValue = element.getAttribute(ATTRIBUTE_NAME) || "";
    var attributeItems = splitAndRemoveDuplicates(attributeValue);
    for (var _len2 = arguments.length, names = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      names[_key2 - 1] = arguments[_key2];
    }
    var promises = names.map(function (name) {
      if (!_this3.isWidgetApplied(element, name)) {
        console.warn("Widget \"" + name + "\" was not applied to this element.");
        return Promise.resolve();
      }
      removeFromArray(attributeItems, name);
      return _this3._destroyWidget(element, name);
    });
    Promise.allSettled(promises).then(function () {
      mutateDOM(function () {
        if (attributeItems.length) {
          element.setAttribute(ATTRIBUTE_NAME, attributeItems.join(" "));
        } else {
          element.removeAttribute(ATTRIBUTE_NAME);
        }
      });
    });
  },
  /**
   * Удаление всех виджетов, привязанных к элементу.
   * @param {HTMLElement} element
   */
  deleteAllWidgets: function deleteAllWidgets(element) {
    this._destroyAllFromAttribute(element).then(function () {
      mutateDOM(function () {
        element.removeAttribute(ATTRIBUTE_NAME);
      });
    });
  },
  /**
   * Ищет ближайший родительский элемент, к которому применён указанный виджет.
   * @param {HTMLElement} element
   * @param {string} name
   * @returns {HTMLElement|null}
   */
  findClosest: function findClosest(element, name) {
    var current = element;
    while (1) {
      if (this.isWidgetApplied(current, name)) {
        return current;
      } else if (!(current = current.parentElement)) {
        return null;
      }
    }
  },
  /**
   * Ищет первый дочерний элемент, к которому применён указанный виджет.
   * @param {Node|Document} root
   * @param {string} name
   * @returns {HTMLElement|null}
   */
  find: function find(root, name) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, null, false);
    var node;
    while (node = walker.nextNode()) {
      if (this.isWidgetApplied(node, name)) {
        return node;
      }
    }
    return null;
  },
  /**
   * Ищет все дочерние элементы, к которым применён указанный виджет.
   * @param {Node|Document} root
   * @param {string} name
   * @returns {HTMLElement[]}
   */
  findAll: function findAll(root, name) {
    var result = [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, null, false);
    var node;
    while (node = walker.nextNode()) {
      if (this.isWidgetApplied(node, name)) {
        result.push(node);
      }
    }
    return result;
  },
  /**
   * Применение виджетов в поддереве элемента root.
   * @param {HTMLElement|Document} [root=document.documentElement]
   * @return {Promise}
   */
  initTree: function initTree(root) {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var promises;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (root === void 0) {
              root = document.documentElement;
            }
            if (!(root.nodeType === document.ELEMENT_NODE && root.matches(SELECTOR))) {
              _context6.next = 4;
              break;
            }
            _context6.next = 4;
            return _this4._applyAllFromAttribute(root);
          case 4:
            promises = Array.from(root.querySelectorAll(SELECTOR)).map(function (node) {
              return _this4._applyAllFromAttribute(node);
            });
            _context6.next = 7;
            return Promise.allSettled(promises);
          case 7:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  /**
   * Удаление всех виджетов в поддереве элемента root.
   * @param {HTMLElement|Document} [root=document.documentElement]
   * @return {Promise}
   */
  destroyTree: function destroyTree(root) {
    var _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var promises;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (root === void 0) {
              root = document.documentElement;
            }
            if (!(root.nodeType === document.ELEMENT_NODE && root.matches(SELECTOR))) {
              _context7.next = 4;
              break;
            }
            _context7.next = 4;
            return _this5._destroyAllFromAttribute(root);
          case 4:
            promises = Array.from(root.querySelectorAll(SELECTOR)).map(function (node) {
              return _this5._destroyAllFromAttribute(node);
            });
            _context7.next = 7;
            return Promise.allSettled(promises);
          case 7:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  },
  // =================================================================================
  //   Private methods
  // =================================================================================
  /**
   * Получение списка имён виджетов, которые применены к данному элементу.
   * @param {HTMLElement} element
   * @returns {string[]}
   * @private
   */
  _getAppliedWidgets: function _getAppliedWidgets(element) {
    var appliedWidgets = element[APPLIED_WIDGETS_PROPERTY_NAME];
    if (!Array.isArray(appliedWidgets)) {
      element[APPLIED_WIDGETS_PROPERTY_NAME] = appliedWidgets = [];
    }
    return appliedWidgets;
  },
  /**
   * Иницаилизация виджета(-ов) на заданном элементе.
   * Если виджет не зарегистрирован или уже применён - он пропускается.
   * @param {HTMLElement} element
   * @param {string} names
   * @return {Promise}
   * @private
   */
  _initWidget: function _initWidget(element) {
    var _this6 = this;
    var appliedWidgets = this._getAppliedWidgets(element);
    var promises = [];
    for (var _len3 = arguments.length, names = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      names[_key3 - 1] = arguments[_key3];
    }
    names.forEach(function (name) {
      if (!_this6._registered.has(name)) {
        console.debug("Widget \"" + name + "\" is not registered.");
        return;
      }
      var widgetObject = _this6._registered.get(name);
      if (appliedWidgets.includes(name)) {
        return;
      }
      if (Array.isArray(widgetObject.dependencies)) {
        widgetObject.dependencies.forEach(function (depName) {
          promises.push(_this6._initWidget(element, depName));
        });
      }
      var initResult;
      if (widgetObject.init) {
        initResult = widgetObject.init(element, widgetObject);
      }
      appliedWidgets.push(name);
      if (initResult instanceof Promise) {
        promises.push(initResult.then(function () {
          dispatch(element, "xclass:init-widget", {
            name: name,
            widgetObject: widgetObject
          });
        }));
      } else {
        dispatch(element, "xclass:init-widget", {
          name: name,
          widgetObject: widgetObject
        });
      }
    });
    return Promise.allSettled(promises);
  },
  /**
   * Освобождение ресурсов виджета(-ов) для заданного элемента.
   * Если виджет не зарегистрирован или не применён - он пропускается.
   * @param {HTMLElement} element
   * @param {string} names
   * @return {Promise}
   * @private
   */
  _destroyWidget: function _destroyWidget(element) {
    var _this7 = this;
    var appliedWidgets = this._getAppliedWidgets(element);
    var promises = [];
    for (var _len4 = arguments.length, names = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      names[_key4 - 1] = arguments[_key4];
    }
    names.forEach(function (name) {
      if (!_this7._registered.has(name)) {
        console.debug("Widget \"" + name + "\" is not registered.");
        return;
      }
      var widgetObject = _this7._registered.get(name);
      if (!appliedWidgets.includes(name)) {
        return;
      }
      var destroyResult;
      if (widgetObject.destroy) {
        destroyResult = widgetObject.destroy(element, widgetObject);
      }
      removeFromArray(appliedWidgets, name);
      if (destroyResult instanceof Promise) {
        promises.push(destroyResult.then(function () {
          dispatch(element, "xclass:destroy-widget", {
            name: name,
            widgetObject: widgetObject
          });
        }));
      } else {
        dispatch(element, "xclass:destroy-widget", {
          name: name,
          widgetObject: widgetObject
        });
      }
      if (Array.isArray(widgetObject.dependencies)) {
        widgetObject.dependencies.reverse().forEach(function (depName) {
          promises.push(_this7._destroyWidget(element, depName));
        });
      }
    });
    return Promise.allSettled(promises);
  },
  /**
   * Применение всех виджетов из атрибута.
   * Поскольку _initWidget пропускает виджеты, которые уже применены,
   * данный метод является идемпотентным.
   * @param {HTMLElement} element
   * @return {Promise}
   * @private
   */
  _applyAllFromAttribute: function _applyAllFromAttribute(element) {
    var _this8 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var attributeValue, widgetsToApply;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            attributeValue = element.getAttribute(ATTRIBUTE_NAME) || "";
            widgetsToApply = splitAndRemoveDuplicates(attributeValue);
            _context8.next = 4;
            return _this8._initWidget.apply(_this8, [element].concat(widgetsToApply));
          case 4:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  },
  /**
   * Освобождение ресурсов всех виджетов из атрибута.
   * Поскольку _destroyWidget пропускает виджеты, которые не применены,
   * данный метод является идемпотентным.
   * @param {HTMLElement} element
   * @return {Promise}
   * @private
   */
  _destroyAllFromAttribute: function _destroyAllFromAttribute(element) {
    var _this9 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      var attributeValue, widgetsToRemove;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            attributeValue = element.getAttribute(ATTRIBUTE_NAME) || "";
            widgetsToRemove = splitAndRemoveDuplicates(attributeValue);
            _context9.next = 4;
            return _this9._destroyWidget.apply(_this9, [element].concat(widgetsToRemove));
          case 4:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }))();
  }
};

export { XClass as default };
